import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';

export interface BlockAnimationBlockData {
  imgLeft: BlockComponentImage,
  imgRight: BlockComponentImage,
  text1: BlockComponentText,
  text2: BlockComponentText,
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace BlockAnimationBlockData {
  interface MakeProps {
    imgLeftUrl: string
    imgRightUrl: string
    text1: string
    text2: string
  }

  export const make = (props: MakeProps): BlockAnimationBlockData => {
    const {
      imgLeftUrl, imgRightUrl, text1, text2,
    } = props;
    return {
      imgLeft: BlockComponentImage.make(imgLeftUrl),
      imgRight: BlockComponentImage.make(imgRightUrl),
      text1: BlockComponentText.make(text1),
      text2: BlockComponentText.make(text2),
    };
  };

  export const getDefault = (defaultImageUrl = ''): BlockAnimationBlockData => {
    const defaultText = 'ここをクリックして表示したいテキストを入力してください。テキストは「太字」「文字サイズ」など編集することができます。';
    return {
      imgLeft: BlockComponentImage.make(defaultImageUrl),
      imgRight: BlockComponentImage.make(defaultImageUrl),
      text1: BlockComponentText.make(defaultText),
      text2: BlockComponentText.make(defaultText),
    };
  };
}
